import { render, staticRenderFns } from "./BaseWelfare.vue?vue&type=template&id=3d08dbb9&scoped=true"
import script from "./BaseWelfare.vue?vue&type=script&lang=js"
export * from "./BaseWelfare.vue?vue&type=script&lang=js"
import style0 from "./BaseWelfare.vue?vue&type=style&index=0&id=3d08dbb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d08dbb9",
  null
  
)

export default component.exports